import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { SlideOptionsComponent } from '@ux/components/product-upsell/slide-options/slide-options.component';
import { CarouselModule } from '@app/modules/carousel/carousel.module';
import { SlideOptionComponent } from '@ux/components/product-upsell/slide-option/slide-option.component';
import {
  CoraouselPlaceholderComponent
} from '@ux/components/product-upsell/placeholders/coraousel-placeholder/coraousel-placeholder.component';
import {
  TitlePlaceholderComponent
} from '@ux/components/product-upsell/placeholders/title-placeholder/title-placeholder.component';
import {
  ContentPlaceholderComponent
} from '@ux/components/product-upsell/placeholders/content-placeholder/content-placeholder.component';
import {
  DetailPlaceholderComponent
} from '@ux/components/product-upsell/placeholders/detail-placeholder/detail-placeholder.component';
import {
  UpsellSectionVariationComponent
} from '@ux/components/product-upsell/upsell-section-variation/upsell-section-variation.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { RadioButtonDsComponent } from '@design-system/components/organisms/radio-button/radio-button.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@NgModule({
  declarations: [
    SlideOptionsComponent,
    SlideOptionComponent,
    CoraouselPlaceholderComponent,
    TitlePlaceholderComponent,
    ContentPlaceholderComponent,
    DetailPlaceholderComponent,
    UpsellSectionVariationComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    TranslocoModule,
    GlobalPipesModule,
    RadioButtonDsComponent,
    IconDsComponent,
    TypographyDsComponent,
    DividerDsComponent,
  ],
  exports: [
    SlideOptionsComponent,
    SlideOptionComponent,
    UpsellSectionVariationComponent
  ]
})
export class ProductUpsellModule { }
